var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 12,
    ry: 12,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 12 12)",
    fill: "#006FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4378 13.0356L9.66976 15.2675C10.1315 15.7293 10.7867 15.6898 11.3078 15.1688L16.1707 10.3059C16.6917 9.78485 16.7312 9.12964 16.2694 8.66786C15.8076 8.20607 15.1524 8.24557 14.6314 8.76659L10.6369 12.7611L9.17456 11.2988C8.71277 10.837 8.05756 10.8765 7.53654 11.3976C7.01551 11.9186 6.97602 12.5738 7.4378 13.0356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircleBlue);
export default __webpack_public_path__ + "static/media/checked-circle-blue.3e3c571f228167b1330412777622532b.svg";
export { ForwardRef as ReactComponent };